var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGirlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-girl"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1741",
    "data-name": "Rectangle 1741",
    width: 64,
    height: 64,
    rx: 15,
    fill: "#132320",
    stroke: "#132320",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GIRL",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1739",
    "data-name": "Rectangle 1739",
    fill: "none",
    stroke: "#132320",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 66,
    height: 66,
    rx: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_73",
    "data-name": "Mask Group 73",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-girl)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_046-woman",
    "data-name": "046-woman",
    d: "M95.894,2.791a.879.879,0,1,0-.869,1.529,7.055,7.055,0,0,1,3.566,6.122V26.619a4.294,4.294,0,0,1-3.407-4.2V11.816A11.83,11.83,0,0,0,83.368,0H77.982a11.744,11.744,0,0,0-6.014,1.649H69.793A8.8,8.8,0,0,0,61,10.442V27.589a.879.879,0,0,0,.879.879,6.03,6.03,0,0,0,2.016-.345.879.879,0,0,0-.586-1.658,4.249,4.249,0,0,1-.55.154V10.442A7.042,7.042,0,0,1,69.687,3.41a11.78,11.78,0,0,0-3.521,8.406V32.975a.88.88,0,0,0,1.308.768,8.279,8.279,0,0,0,3.568-3.909,11.839,11.839,0,0,0,4.578,3.879v.232a3.668,3.668,0,0,1-3.674,3.665,9.071,9.071,0,0,0-9.076,9.076v5.194a.879.879,0,1,0,1.759,0V46.687a7.313,7.313,0,0,1,7.318-7.317c.149,0,.307-.007.48-.022,5.4,4.708,9.426,3.772,16.808,1.718a.879.879,0,0,0-.471-1.694c-6.385,1.776-9.4,3.186-14.295-.619a5.414,5.414,0,0,0,2.892-4.371,11.753,11.753,0,0,0,12.95-4.546,8.28,8.28,0,0,0,3.568,3.909.88.88,0,0,0,1.307-.768V26.681a6.026,6.026,0,0,0,4.287,1.787.879.879,0,0,0,.879-.879V10.442a8.817,8.817,0,0,0-4.456-7.651ZM93.426,31.254a6.451,6.451,0,0,1-1.941-3.523,11.7,11.7,0,0,0,.952-4.567c0-6.624.008-6.179-.02-6.311a.88.88,0,0,0-.528-.63,8.158,8.158,0,0,1-3.155-1.712,7.879,7.879,0,0,1-2.075-2.965.88.88,0,0,0-1.6-.082A11.142,11.142,0,0,1,80.705,16a5.452,5.452,0,0,0-.693-2.361.88.88,0,0,0-1.492-.066,7.628,7.628,0,0,1-6.136,3.6.879.879,0,0,0,.02,1.758,8.728,8.728,0,0,0,2.006-.274,9.442,9.442,0,0,0,4.519-2.784,3.689,3.689,0,0,1-.094,1.38.88.88,0,0,0,1.187,1.035,12.978,12.978,0,0,0,5.749-4.605,9.566,9.566,0,0,0,4.906,3.991V23.1a9.945,9.945,0,0,1-.833,3.994.879.879,0,0,0-.13.285,10,10,0,0,1-18.079,0,.879.879,0,0,0-.13-.285c-1-2.278-.833-3.931-.833-6.536a.879.879,0,1,0-1.759,0c0,2.739-.163,4.585.952,7.175a6.451,6.451,0,0,1-1.941,3.524V11.816A10.069,10.069,0,0,1,77.982,1.759h5.386A10.069,10.069,0,0,1,93.426,11.816Zm5.056,15.433v5.194a.879.879,0,0,1-1.759,0V46.687a7.313,7.313,0,0,0-7.318-7.317,5.4,5.4,0,0,1-4.645-2.608.879.879,0,0,1,1.5-.915,3.653,3.653,0,0,0,3.143,1.764,9.071,9.071,0,0,1,9.076,9.076Z",
    transform: "translate(-48.464 16.797)",
    fill: "#132320"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlIcon);
export default __webpack_public_path__ + "static/media/girl-icon.88f9e140.svg";
export { ForwardRef as ReactComponent };